export interface Scenario {
  id: number;
  name: string;
  icon: string | null;
  glosa: string;
}

const SCENARIOS_STORAGE_KEY = "scenarios";

export function getScenarios(): Scenario[] {
  try {
    const raw = localStorage.getItem(SCENARIOS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function normalizeForLookup(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function findScenarioByName(matchedText: string, scenarios: Scenario[]): Scenario | undefined {
  const target = normalizeForLookup(matchedText);
  return scenarios.find((s) => normalizeForLookup(s.name) === target);
}